// libs/react-mosaic-component/src/lib/contextTypes.ts
import React from "react";
var MosaicContext = React.createContext(
  void 0
);
var MosaicWindowContext = React.createContext(
  void 0
);
export {
  MosaicContext,
  MosaicWindowContext
};
